import * as React from 'react';
import { Box, Typography, Container, IconButton, alpha } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HiHeart } from 'react-icons/hi';
import { FaGithub, FaTwitter, FaDiscord } from 'react-icons/fa';

const footerLinks = [
  {
    title: 'Platform',
    links: ['Browse', 'Trending', 'Popular', 'Schedule', 'Watchlist'],
  },
  {
    title: 'Genres',
    links: ['Action', 'Romance', 'Fantasy', 'Comedy', 'Horror', 'Sci-Fi'],
  },
  {
    title: 'Support',
    links: ['FAQ', 'Contact', 'Privacy Policy', 'Terms of Service', 'DMCA'],
  },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: '#050505',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        pt: { xs: 6, md: 10 },
        pb: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '2fr 1fr 1fr 1fr' },
            gap: { xs: 4, md: 6 },
            mb: { xs: 6, md: 8 },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: '1.5rem',
                fontWeight: 800,
                letterSpacing: '-0.5px',
                background: 'linear-gradient(135deg, #8B5CF6, #EC4899)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                mb: 2,
                cursor: 'pointer',
              }}
              onClick={() => navigate('/')}
            >
              AnimeFlow
            </Typography>
            <Typography sx={{ color: '#64748B', fontSize: '0.9rem', maxWidth: 320, lineHeight: 1.7, mb: 3 }}>
              Your ultimate destination for streaming anime. Thousands of series and movies,
              always available whenever you want.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {[FaGithub, FaTwitter, FaDiscord].map((Icon, i) => (
                <IconButton
                  key={i}
                  size="small"
                  sx={{
                    color: '#64748B',
                    background: alpha('#fff', 0.05),
                    '&:hover': {
                      color: '#8B5CF6',
                      background: alpha('#8B5CF6', 0.1),
                    },
                  }}
                >
                  <Icon size={16} />
                </IconButton>
              ))}
            </Box>
          </Box>

          {footerLinks.map((group) => (
            <Box key={group.title}>
              <Typography
                sx={{
                  fontSize: '0.85rem',
                  fontWeight: 700,
                  color: '#94A3B8',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  mb: 2,
                }}
              >
                {group.title}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {group.links.map((link) => (
                  <Typography
                    key={link}
                    sx={{
                      fontSize: '0.9rem',
                      color: '#64748B',
                      cursor: 'pointer',
                      transition: 'color 0.2s',
                      '&:hover': { color: '#F8FAFC' },
                    }}
                    onClick={() => {
                      if (link === 'Browse') navigate('/browse');
                      else if (link === 'Trending') navigate('/home');
                      else if (link === 'Popular') navigate('/home');
                      else if (link === 'Schedule') navigate('/schedule');
                      else if (link === 'Watchlist') navigate('/watchlist');
                    }}
                  >
                    {link}
                  </Typography>
                ))}
              </Box>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            pt: 4,
            borderTop: '1px solid rgba(255,255,255,0.05)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography sx={{ color: '#475569', fontSize: '0.85rem' }}>
            &copy; {new Date().getFullYear()} AnimeFlow. All rights reserved.
          </Typography>
          <Typography
            sx={{
              color: '#475569',
              fontSize: '0.85rem',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            Made with <HiHeart size={14} color="#EC4899" /> for the anime community
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
